import { lazyLoadMedia, observeLazyMedia } from './utils/lazyload';
import { addPreloadToLCP } from './utils/LCPFile';
import { initSwiper, observeSwipers } from './library/swiper';
import { initDetailCardSwiper } from './library/initDetailCardSwiper';
import { initFancybox } from './library/fancybox';
import { initNotyf } from './library/notification';
import { initializeTabs } from './library/tabs';
import { initTooltip } from './library/typpy';
import { initMarquee } from './library/marquee';
import { modal } from './library/modal';
import { initAccordion } from './library/accordion';
import 'dragscroll';
import {initMenuTable} from "./main/initMenuTable";
import {initFooterAccordion} from "./main/initFooterAccordion";
import {initMenuMobile} from "./main/initMenuMobile";
import {initMobileMenuScroll} from "./main/initMobileMenuScroll";
import {initHeaderFixed} from "./main/initHeaderFixed";
import {initCatalogButton} from "./main/initCatalogButton";
import {initMainMenu} from "./main/initMainMenu";
import {initMobileMenu} from "./main/initMobileMenu";
import {initDropDownFilter1} from "./filter/initDropDownFilter1";
import {initDropDownFilter2} from "./filter/initDropDownFilter2";
import {initDropDownFilter3} from "./filter/initDropDownFilter3";
import {initScrollBoxes} from "./main/initScrollBoxes";
import {initCheckWidth} from "./main/initCheckWidth";
import {initBurgerMenu} from "./main/initBurgerMenu";
import {initGalleryModal} from "./main/initGalleryModal";
import {initImageZoom} from "./main/initImageZoom";
import {initBoxContainerCounter} from "./main/initBoxContainerCounter";
import {initTabs1} from "./main/initTabs1";
import {initVideoIframeLoader} from "./main/initVideoIframeLoader";
import {initCopyBox} from "./main/initCopyBox";
import {initFormValidation} from "./main/initFormValidation";
import {initCookiesModal} from "./main/initCookiesModal";

window.lazyLoadMedia = lazyLoadMedia;
window.addPreloadToLCP = addPreloadToLCP;
window.initSwiper = initSwiper;

document.addEventListener('DOMContentLoaded', () => {
    lazyLoadMedia();
    observeLazyMedia();
    //initAccordion();
    initSwiper();
    observeSwipers();
    initDetailCardSwiper();
    initFancybox();
    initFooterAccordion();
    initMenuTable();
    initMenuMobile();
    initMobileMenuScroll();
    initHeaderFixed();
    initCatalogButton();
    initMainMenu();
    initMobileMenu();
    initDropDownFilter1();
    initDropDownFilter2();
    initDropDownFilter3();
    initScrollBoxes();
    initCheckWidth();
    initBurgerMenu();
    initGalleryModal();
    initCookiesModal();
    initImageZoom();
    initBoxContainerCounter();
    initTabs1();
    initVideoIframeLoader();
    initCopyBox();

    initFormValidation();

    // initNotyf();
    // initializeTabs();
    // initTooltip();
    // initMarquee();
    modal;
});

